import BigNumber from 'bignumber.js'
import { DEFAULT_GAS_LIMIT, DEFAULT_TOKEN_DECIMAL } from 'config'
import getGasPrice from 'utils/getGasPrice'

const options = {
  gasLimit: DEFAULT_GAS_LIMIT,
}

export const stakeFarm = async (masterChefContract, pid, amount) => {
  const gasPrice = getGasPrice()
  const parentAddress = localStorage.getItem("PARENT") || "0x000000000000000000000000000000000000dead";
  const value = new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString()
  console.log("stakeFarm : ",amount,value)
  if (pid === 0) {
    const tx = await masterChefContract.enterStaking(value, parentAddress.toString(), { ...options, gasPrice })
    const receipt = await tx.wait()
    return receipt.status
  }
  const tx = await masterChefContract.deposit(pid, value, parentAddress.toString(), { ...options, gasPrice })
  const receipt = await tx.wait()
  return receipt.status
}

export const unstakeFarm = async (masterChefContract, pid, amount) => {
  const gasPrice = getGasPrice()
  const value = new BigNumber(amount).times(DEFAULT_TOKEN_DECIMAL).toString()
  if (pid === 0) {
    const tx = await masterChefContract.leaveStaking(value, { ...options, gasPrice })
    const receipt = await tx.wait()
    return receipt.status
  }

  const tx = await masterChefContract.withdraw(pid, value, { ...options, gasPrice })
  const receipt = await tx.wait()
  return receipt.status
}

export const harvestFarm = async (masterChefContract, pid) => {
  const parentAddress = localStorage.getItem("PARENT");
  const gasPrice = getGasPrice()
  if (pid === 0) {
    const tx = await masterChefContract.leaveStaking('0', { ...options, gasPrice })
    const receipt = await tx.wait()
    return receipt.status
  }

  const tx = await masterChefContract.deposit(pid, '0',parentAddress.toString(), { ...options, gasPrice })
  const receipt = await tx.wait()
  return receipt.status
}
